module.exports = __webpack_public_path__ + "img/5558e18d078cf0d8e415aa928b82742e.png";